import Link from "next/link";
import {ImageWithFallback} from "@/components";

export default function SymbolCard({image, title, url = "/"}) {
    return (
        <Link href={url}
              target="_blank"
              rel="nofollow"
              className="block relative flex-grow bg-white rounded-[1.563rem] px-3.5 py-4 lg:p-5 after:absolute after:w-[38%] after:rounded-[1.938rem] after:h-1 after:bg-pol-blue-light after:top-0 after:right-[31%] hover:brightness-100 after:duration-300 hover:after:bg-pol-purple">
            <div className="relative w-full h-[5.5rem] lg:h-[6.625rem] overflow-hidden rounded-[0.938rem]">
                <ImageWithFallback
                    src={image}
                    alt={title}
                    fill
                    className="object-contain"
                />
            </div>
        </Link>
    )
}
